import { useEffect, useState } from "react";
import { Alert, Col, Container, ListGroup, Row } from "react-bootstrap";
import { Eye } from "react-feather";
import { Helmet } from "react-helmet-async";

import { LoadingBox } from "../../components/Loader";
import CartonForm from "./components/buildShipment/CartonForm";
import ShipmentRackItems from "./components/buildShipment/ShipmentRackItems";
import ShipmentRacks from "./components/buildShipment/ShipmentRacks";

import shipmentService from "../../services/shipmentService";
import utilsService from "../../services/utils.service";

const BuildShipmentPage = () => {
  const [initializing, setInitializing] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [listingAccounts, setListingAccounts] = useState([]);
  const [shipmentCategories, setShipmentCategories] = useState([]);
  const [shipmentCartonTypes, setShipmentCartonTypes] = useState([]);

  const [shipmentRacks, setShipmentRacks] = useState([]);
  const [shipments, setShipments] = useState([]); // For shipmentRackItems component

  const [selectedListingAccount, setSelectedListingAccount] = useState();
  const [selectedShipmentRack, setSelectedShipmentRack] = useState();
  const [selectedShipmentRackItems, setSelectedShipmentRackItems] = useState();

  const [activeKey, setActiveKey] = useState(null); // For the accordion in shipmentRackItems

  useEffect(() => {
    const controller = new AbortController();

    const initialize = async () => {
      try {
        const listingAccountsResult = await utilsService.getListingAccounts(
          {
            amazonOnly: true,
          },
          controller.signal
        );

        if (listingAccountsResult.success) {
          setListingAccounts(listingAccountsResult.listingAccounts);
        }

        const shipmentCategoriesResult =
          await shipmentService.getShipmentCategories(controller.signal);

        if (shipmentCategoriesResult.success) {
          setShipmentCategories(shipmentCategoriesResult.shipmentCategories);
        }

        const shipmentCartonTypesResult =
          await shipmentService.getShipmentCartonTypes(controller.signal);

        if (shipmentCartonTypesResult.success) {
          setShipmentCartonTypes(shipmentCartonTypesResult.shipmentCartonTypes);
        }
      } finally {
        if (!controller.signal.aborted) {
          setInitializing(false);
        }
      }
    };

    initialize();

    return () => controller.abort();
  }, []);

  // When an account is selected, reset the rack and items states
  useEffect(() => {
    setSelectedShipmentRack();
    setSelectedShipmentRackItems();
  }, [selectedListingAccount]);

  return (
    <>
      <Helmet title="Build Shipment" />
      <h1 className="mb-3">Build Shipment</h1>
      <Container fluid className="p-0">
        {initializing ? (
          <LoadingBox />
        ) : (
          listingAccounts && (
            <Row className="mb-3">
              <Col>
                <ListGroup horizontal>
                  {listingAccounts.map((account, index) => {
                    return (
                      <ListGroup.Item
                        tag="a"
                        key={index}
                        className="text-center"
                        onClick={() => setSelectedListingAccount(account)}
                        action
                        active={selectedListingAccount === account}
                        // disabled={submitting}
                      >
                        {account.listingAccount}
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              </Col>
            </Row>
          )
        )}
        {!selectedListingAccount ? (
          <Row>
            <Col>
              <Alert variant="primary">
                <div className="alert-icon">
                  <Eye
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message">
                  Select an <strong>account</strong> to view shipment racks.
                </div>
              </Alert>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xl={8}>
              <ShipmentRacks
                selectedListingAccount={selectedListingAccount}
                shipmentCategories={shipmentCategories}
                setSelectedShipmentRack={setSelectedShipmentRack}
                submitting={submitting}
                shipmentRacks={shipmentRacks}
                setShipmentRacks={setShipmentRacks}
                setSelectedShipmentRackItems={setSelectedShipmentRackItems}
              />
              {selectedShipmentRack && selectedShipmentRackItems && (
                <ShipmentRackItems
                  selectedShipmentRack={selectedShipmentRack}
                  setSelectedShipmentRack={setSelectedShipmentRack}
                  selectedShipmentRackItems={selectedShipmentRackItems}
                  shipments={shipments}
                  setShipments={setShipments}
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                />
              )}
            </Col>
            {selectedShipmentRack && (
              <Col xl={4}>
                <CartonForm
                  selectedListingAccount={selectedListingAccount}
                  selectedShipmentRack={selectedShipmentRack}
                  selectedShipmentRackItems={selectedShipmentRackItems}
                  setActiveKey={setActiveKey}
                  setSelectedShipmentRackItems={setSelectedShipmentRackItems}
                  setSubmitting={setSubmitting}
                  shipmentCartonTypes={shipmentCartonTypes}
                  shipmentCategories={shipmentCategories}
                  shipments={shipments}
                  submitting={submitting}
                />
              </Col>
            )}
          </Row>
        )}
      </Container>
    </>
  );
};

export default BuildShipmentPage;
